import { zonedTimeToUtc } from 'date-fns-tz';

/**
 * 會員養成
 * @returns {object} 
 * {
 *  point1: 註冊得點
 *  point2: 觀劇得點
 *  date: 點數發放日期
 * }
 * 
 * { 第一檔活動 2021/12/07 10:00 ~ 2021/12/31 23:59
 * point1: 5, 
 * point2: 3,
 * date: '2022/01/28',
 * }
 * * { 第二檔之後的活動 2022/01/01 00:00 ~ 2022/01/31 23:59、2022/02/01 00:00 ~ 2022/02/28 23:59 ... 以月份為檔次
 * point1: 5, 
 * point2: 3,
 * date: '完成任務次月底',
 * }
 * */
export const returnCampaignWording = () => {
  const today = zonedTimeToUtc(new Date(), "Asia/Taipei");
  const changeDate = zonedTimeToUtc(new Date(2022, 0, 1, 0, 0, 0), "Asia/Taipei"); // 月份從 0 起算
  
  const shouldCampaignChanged = Boolean(today > changeDate);
  
  if (shouldCampaignChanged) {
    return { // 第二檔之後的活動
      point1: 5, 
      point2: 3,
      date: '完成任務次月底',
    };
  } else {
    return { // 第一檔活動
      point1: 5, 
      point2: 3,
      date: '2022/01/28',
    };
  }
}